import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientProfileNotesQuery(patientId) {
    return useQuery(
        ['patient', patientId, 'notes'],
        () => (!patientId ? [] : PESService.getPatientProfileNotes(patientId)),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            staleTime: 60000,
            enabled: !!patientId,
        }
    );
}

export default useFetchPatientProfileNotesQuery;
